import React, { Component } from "react";
import { Button, Accordion } from "react-bootstrap";
import { connect } from "react-redux";
import Axios from "axios";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});
class DownloadCard extends Component {
  state = {
    file: [],
  };
  componentDidMount() {
    window.scrollTo(0, 0);
    this.fetchFiles({
      upload_content: this.props.id,
    });
  }

  fetchFiles = (params = {}) => {
    Axios.get(`/api/files`, {
      params: { ...params },
    }).then((res) => {
      this.setState({
        file: res.data,
      });
    });
  };

  render() {
    const handelDt = (dt) => {
      var j = dt % 10,
        k = dt % 100;
      if (j === 1 && k !== 11) {
        return dt + "st";
      }
      if (j === 2 && k !== 12) {
        return dt + "nd";
      }
      if (j === 3 && k !== 13) {
        return dt + "rd";
      }
      return dt + "th";
    };
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];
    const handleDate = (date1) => {
      let year1 = new Date(date1).getFullYear();
      let month1 = new Date(date1).getMonth();
      let dt1 = new Date(date1).getDate();
      year1 = year1 % 100;
      return `${handelDt(dt1)} ${monthNames[month1]}, ${year1}`;
    };
    return (
      <div>
        <div className="border rounded shadow-sm p-3">
          <Accordion defaultActiveKey={null}>
            <div>
              <Accordion.Toggle
                as={Button}
                variant="link"
                eventKey={1}
                style={{
                  padding: 0,
                  textDecoration: "none",
                  boxShadow: "none",
                  width: "100%",
                }}
              >
                <div className="d-flex justify-content-between">
                  <div className="th-12 th-black">
                    {this.props.num + 1}. {this.props.title}
                  </div>
                  <i
                    className="fa fa-paperclip th-primary th-20"
                    aria-hidden="true"
                  ></i>
                </div>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey={1}>
                <div className="py-2">
                  <div className="th-12 th-grey">
                    {handleDate(this.props.date)}
                  </div>
                  <p className="th-12 th-grey">{this.props.desc}</p>
                  {this.state.file.length !== 0
                    ? this.state.file?.map((item) => (
                  <div className="text-center">
                    <a
                      className="btn th-btn-primary-outline mt-2 px-4 py-1"
                      href={item?.file}
                      download
                    >
                      Download/View
                    </a>
                  </div>
                    )):null}
                </div>
              </Accordion.Collapse>
            </div>
          </Accordion>
        </div>
      </div>
    );
  }
}
export default connect(mapStateToProps)(DownloadCard);
